import { Modal } from '@studiometa/ui';

/**
 * Popin Newsletter class.
 */
export default class PopinNewsletter extends Modal {
  static config = {
    name: 'PopinNewsletter',
    options: {
      delay: {
        type: Number,
        default: 7000,
      },
      autofocus: {
        type: String,
        default: '[type="email"]',
      },
    },
  };

  /**
   * Mounted
   */
  mounted() {
    super.mounted();

    if (localStorage.getItem('newsletter_displayed')) {
      return;
    }

    setTimeout(() => {
      this.open();
    }, this.$options.delay);
  }

  /**
   * Close the modal.
   * @returns {Promise<void>}
   */
  async close() {
    if (!this.isOpen) {
      return;
    }

    localStorage.setItem('newsletter_displayed', true);
    await super.close();
  }
}
